import { apiFetch } from './client'

export type AuditActor = { user_id: string; role: string }

export type AuditEntry = {
  id: number
  actor: AuditActor
  action: string
  target_table: string
  target_id: string
  before: Record<string, string | number | boolean>
  after: Record<string, string | number | boolean>
  occurred_at: string
}

export type AuditLogPage = {
  data: AuditEntry[]
  page: { next_cursor: string | null; limit: number }
}

export const AUDIT_LOG_KEY = ['admin', 'audit-log'] as const

/** GET /api/v1/admin/audit-log — cursor-paginated, newest-first. For amtc_admin,
 * an optional `hospitalId` (the "Managing" picker) scopes to one hospital; omit
 * for all. Ignored server-side for a hospital_admin (always their own). */
export async function fetchAuditLog(
  token: string | null,
  cursor?: string | null,
  hospitalId?: string | null,
): Promise<AuditLogPage> {
  const params = new URLSearchParams()
  if (cursor) params.append('cursor', cursor)
  if (hospitalId) params.append('hospital_id', hospitalId)
  const qs = params.toString()
  return apiFetch<AuditLogPage>(
    `/api/v1/admin/audit-log${qs ? `?${qs}` : ''}`,
    { token },
  )
}
